export const mutations = {
    setActivated(state, value) {
        state.activated = value;
    },
    setIsBuyingPack(state, value) {
        state.is_buying_pack = value;
    },
    setLastPaymentMethod(state, value) {
        state.last_payment_method = value;
    },
    set(state, value) {
        state.activated = value.activated;
        state.is_buying_pack = value.is_buying_pack;
        state.last_payment_method = value.last_payment_method ?? null;
    },
};

export default mutations;
